import {NativeModule} from './native-module';

export function getIsWatchAppInstalled() {
  return NativeModule.getIsWatchAppInstalled();
}
